// AmountChip — MD3 Chip с числом и валютой (ISO-код string, не union 4).
import { Chip } from '@mui/material';
import { formatMoney } from '@/lib/format';

interface AmountChipProps {
  /** Сумма (или null если не указана). */
  amount: number | null;
  /** ISO-код валюты (строка каталога). */
  currency: string;
  /** Размер чипа. */
  size?: 'small' | 'medium';
}

/** MD3 Chip для отображения суммы сделки в указанной валюте. */
export function AmountChip({ amount, currency, size = 'small' }: AmountChipProps): JSX.Element {
  const label = formatMoney(amount, currency);
  return (
    <Chip
      data-testid="amount-chip"
      label={label}
      size={size}
      variant="outlined"
      title={amount === null ? 'Сумма не указана' : `${currency} ${amount}`}
    />
  );
}
